import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";

type AiPlanSelectClearButtonProps = Readonly<{
  visible: boolean;
  disabled?: boolean;
  onClear: () => void;
  "aria-label"?: string;
}>;

/**
 * Clear (X) control for MUI Select filters — placed via Select `endAdornment`
 * instead of an empty MenuItem for clearing.
 */
export default function AiPlanSelectClearButton({
  visible,
  disabled = false,
  onClear,
  "aria-label": ariaLabel = "Clear",
}: AiPlanSelectClearButtonProps) {
  if (!visible || disabled) return null;

  return (
    <IconButton
      size="small"
      aria-label={ariaLabel}
      tabIndex={-1}
      onMouseDown={(event) => {
        // Keep Select from opening / stealing the click.
        event.preventDefault();
        event.stopPropagation();
      }}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClear();
      }}
      sx={{
        position: "absolute",
        right: 28,
        top: "50%",
        transform: "translateY(-50%)",
        p: 0.25,
        color: "action.active",
      }}
    >
      <ClearIcon sx={{ fontSize: 18 }} />
    </IconButton>
  );
}
